import React, { useEffect, useState, useMemo } from "react";
import { getSiteConfig } from "@/lib/api";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import ResearchSection from "@/components/ResearchSection";
import ProjectsSection from "@/components/ProjectsSection";
import TeamSection from "@/components/TeamSection";
import PartnersSection from "@/components/PartnersSection";
import NewsSection from "@/components/NewsSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

const SECTION_COMPONENTS = {
  hero: HeroSection,
  about: AboutSection,
  research: ResearchSection,
  projects: ProjectsSection,
  team: TeamSection,
  partners: PartnersSection,
  news: NewsSection,
  contact: ContactSection,
};

const DEFAULT_SECTIONS = [
  { key: "hero", visible: true, order: 0 },
  { key: "about", visible: true, order: 1 },
  { key: "research", visible: true, order: 2 },
  { key: "projects", visible: true, order: 3 },
  { key: "team", visible: true, order: 4 },
  { key: "partners", visible: true, order: 5 },
  { key: "news", visible: true, order: 6 },
  { key: "contact", visible: true, order: 7 },
];

export default function HomePage() {
  const [sections, setSections] = useState(null);

  useEffect(() => {
    getSiteConfig("homepage_sections").then(r => {
      const s = r.data?.data?.sections;
      if (s && s.length > 0) setSections(s);
    }).catch(() => {});
    getSiteConfig("seo").then(r => {
      const s = r.data?.data;
      if (s) {
        if (s.site_title) document.title = s.site_title;
        const metaDesc = document.querySelector('meta[name="description"]');
        if (metaDesc && s.site_description) metaDesc.setAttribute("content", s.site_description);
        else if (s.site_description) {
          const m = document.createElement("meta");
          m.name = "description";
          m.content = s.site_description;
          document.head.appendChild(m);
        }
      }
    }).catch(() => {});
  }, []); // API functions are stable module-level imports

  const orderedSections = useMemo(() =>
    (sections || DEFAULT_SECTIONS)
      .filter(s => s.visible !== false)
      .sort((a, b) => (a.order || 0) - (b.order || 0)),
    [sections]
  );

  return (
    <div data-testid="home-page" className="bg-[#FAFAFA]">
      <Navbar />
      {orderedSections.map(s => {
        const Comp = SECTION_COMPONENTS[s.key];
        if (!Comp) return null;
        return <Comp key={s.key} />;
      })}
      <Footer />
    </div>
  );
}
